<template>
  <!-- <div class="home" :style="{ backgroundImage: `url(${bgImageUrl})` }"> -->
  <div class="home" :style="bgStyle">

    <div class="submitBox">
      <div class="logo"><img :src="logo" alt=""></div>
      <div class="text">{{ title }}</div>
      <el-input v-model="form.mobile" class="input" placeholder="输入手机号，领取优惠卷" />
      <button class="button" @click="getClainCoupon">领取优惠卷</button>
    </div>
    <el-dialog v-model="dialogVisible" width="50%" :show-close="false">
      <span style="font-size: 20px;line-height: 40px;">{{ msg }}</span>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { clainCoupon, getCanvasInfo,getClaimCoupon } from "@/api/api";
import { toast } from "@/utils/tools";
import { MD5 } from 'crypto-js';
import { useRoute } from 'vue-router'
import back from "@/assets/back.png"
// import logos from "@/assets/logo.png"
const route = useRoute()
console.log(route.query.companyCanvasId, "companyCanvasId")
// @ is an alias to /src
const form = ref({
  companyCanvasId: "",
  canvasCode: "456",
  mobile: ""
})
const title = ref("资深优选 高效招聘")
const bgStyle = ref({
  backgroundImage: `url(${back})`
})
const logo = ref()
const msg = ref("")
const dialogVisible = ref(false)
const getClainCoupon = () => {
  if (form.value.mobile == "" || form.value.mobile == null) {
    // toast("请输入手机号", "warning");
    msg.value = "请输入手机号!"
    dialogVisible.value = true
    setTimeout(() => {
      dialogVisible.value = false
    }, 1500);
    return
  }
  // console.log(MD5("13645483943+KUwBAkGc22nxZA6iR5f62A==").toString(), "md5")

  // form.value.canvasCode = MD5(form.value.mobile + "KUwBAkGc22nxZA6iR5f62A==").toString()
  // console.log(form.value)
  // return
  getClaimCoupon(form.value).then(
    (res) => {
      console.log(res, 'getsystemParamValueByCode')
      msg.value = res.msg
      dialogVisible.value = true
      setTimeout(() => {
        dialogVisible.value = false
      }, 1500);

    }
  );
}
// https://image.baidu.com/search/detail?adpicid=0&b_applid=9322306896639151723&bdtype=0&commodity=&copyright=&cs=766916511%2C2442144840&di=7565560840087142401&fr=click-pic&fromurl=http%253A%252F%252Fwww.douyin.com%252Fnote%252F7404637882255805759&gsm=1e&hd=&height=0&hot=&ic=&ie=utf-8&imgformat=&imgratio=&imgspn=0&is=3908015339%2C2306624355&isImgSet=&latest=&lid=a2a8ea5f0000dc40&lm=&objurl=https%253A%252F%252Fp3-pc-sign.douyinpic.com%252Ftos-cn-i-0813c001%252Fo4IuiAZjBXAcOFCxsvgiPAiIA98PRBDEAKDBg~tplv-dy-aweme-images%253Aq75.webp&os=3908015339%2C2306624355&pd=image_content&pi=0&pn=0&rn=1&simid=766916511%2C2442144840&tn=baiduimagedetail&width=0&word=%E5%9B%BE%E7%89%87&z=
const getData = () => {
  form.value.companyCanvasId = route.query.companyCanvasId
  getCanvasInfo({ companyCanvasId: route.query.companyCanvasId }).then(
    (res) => {
      console.log(res, 'getsystemParamValueByCode')
      form.value.canvasCode = res.data.canvasCode
      title.value = res.data.couponTitle
      bgStyle.value.backgroundImage = `url(${res.data.couponBgImage})`;
      logo.value=res.data.couponLogo
    }
  );
}
getData()
</script>
<style scoped>
.home {
  width: 100vw;
  height: 100vh;
  /* background-image: url("@/assets/back.png"); */
  background-size: 100% 100%;
  position: relative;
}

.submitBox {
  width: 70%;
  min-width: 220px;
  position: absolute;
  top: 10%;
  left: 50%;
  transform: translate(-50%, 10%);
  -webkit-transform: translate(-50%, 10%);
}

.logo {
  width: 100%;
  height: 100px;
}

.logo img {
  width: 100px;
  height: 100px;
  margin: 0 auto;
}

.text {
  height: 40px;
  line-height: 40px;
  margin-bottom: 20%;
  color: #fff;
  font-weight: bold;
  font-size: 20px;
}

.input {
  margin-bottom: 20px;
}

:deep(.el-input__inner) {
  height: 44px;
  font-size: 16px;
  text-align: center;
}

.button {
  width: 100%;
  height: 44px;
  font-size: 18px;
  border: 1px solid #edf2fa;
  border-radius: 2px;
  font-weight: 800;
  color: #626262;
}
</style>
